import type { ComponentContentSchema, PageDataMap } from '@vibesites/runtime';
import { isActivePage, mergePages } from '@vibesites/runtime';
import { usePage, RichTextContent } from '@vibesites/runtime/react';
import pagesData from '../pages.json';
import { useSiteFlags } from '../utils/site';

/** Published pages, minus ones that are both hidden from nav and noindexed. */
const LISTED_PAGES = mergePages(pagesData as unknown as PageDataMap).filter(
  (p) => isActivePage(p) && !p.template && !p.path.includes('{{') && (p.visible || !p.noindex),
);

/** Sitemap page body: a button for every published page on the site. */
export function SitemapList() {
  const { alias: current } = usePage();
  const flags = useSiteFlags();
  const pages = LISTED_PAGES.filter((p) => p.alias !== current && flags.hasData(p.alias));

  return (
    <section className="flex flex-col gap-8 bg-[--q-paper] px-[--gutter] py-28 max-[767px]:gap-6 max-[767px]:py-14" id="sitemap-list">
      <RichTextContent path="sitemaplist.title" as="h2" className="h2 [&_p]:m-0" />
      <nav aria-label="Sitemap">
        <ul className="m-0 flex list-none flex-wrap gap-3 p-0 max-[767px]:flex-col max-[767px]:gap-2.5">
          {pages.map((p) => (
            <li key={p.alias}>
              <a className="btn btn-secondary max-[767px]:w-full" href={p.path}>
                {p.name}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SitemapList',
  displayName: 'Sitemap List',
  tokens: {
    'sitemaplist.title': { label: 'Title', type: 'richtext', defaultValue: '<p>All pages</p>' },
  },
};

(SitemapList as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SitemapList;
